/**
 * Route wrapper for the new-user flow.
 *
 * Its own route so the header reads "Novo usuário" and the browser's back button works.
 *
 * @module Pages/Settings/UserManagement
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCreate } from './Components/UserCreate';

export const UserCreatePage = (): JSX.Element => {
  const navigate = useNavigate();
  const backToList = () => {
    navigate('/settings/users');
  };

  return <UserCreate onBack={backToList} onSuccess={backToList} />;
};
